var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#42a5f5}.cls-2{fill:#424242}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital_Marketing",
    "data-name": "Digital Marketing"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34 8a1 1 0 0 0-2 0 1 1 0 0 0 2 0zM41 13a1 1 0 0 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37 0a11 11 0 0 0-10.15 15.23L26 22l5.63-1.41A11 11 0 1 0 37 0zm-7 8a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm3.78 8.62a1 1 0 0 1-1.56-1.24l8-10a1 1 0 0 1 1.56 1.24zM41 17a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM42 32a6 6 0 0 0-6 6v4a6 6 0 0 0 12 0v-4a6 6 0 0 0-6-6zm1 6a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43 28v2.06a8.36 8.36 0 0 0-2 0V28a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v14a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-2h2v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V28a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22 28v-6a3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.49 16.14a27.9 27.9 0 0 1-10.4 3.7c-1.54.22-.35.16-6.09.16a5 5 0 0 0-1 9.9V37a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1c0-2.77.2-2.21-1-3.41V30c10.15 1.45 11.09 4.66 12.49 3.86.73-.41.51.32.51-16.87a1 1 0 0 0-1.51-.85zM2 25a3 3 0 0 1 3-3h4v6H5a3 3 0 0 1-3-3zm7 11H6v-6h2c0 5.08-.27 4.15 1 5.41zm12-4.71a30 30 0 0 0-10-3.16v-6.26a30 30 0 0 0 10-3.16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.e45747635f3a376000c3f6d9fa289660.svg";
export { ForwardRef as ReactComponent };